module.exports = __webpack_public_path__ + "img/kor.d79ed8d6.jpg";